import { useState } from "react";

export default function SubscribeBand() {
  const [enabled, setEnabled] = useState(false);
  const [tipVisible, setTipVisible] = useState(false);

  const handleToggle = () => {
    setEnabled((prev) => !prev);
    setTipVisible(true);
    window.setTimeout(() => setTipVisible(false), 2200);
  };

  return (
    <section className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
      <div className="flex flex-col items-start gap-6 rounded-lg border border-background-200/80 bg-background-50 p-6 md:flex-row md:items-center md:justify-between md:p-9">
        <div className="max-w-xl">
          <h2 className="font-heading text-xl font-bold tracking-tight text-foreground-950 md:text-3xl">
            不想一条条翻？开启更新提醒
          </h2>
          <p className="mt-2 text-sm leading-relaxed text-foreground-600">
            开启后，本页会为你标记当日新增的黑料合集与打包更新，回到首页就能一眼看到变化，不用再反复确认。
          </p>
        </div>
        <div className="flex flex-col items-start gap-2 sm:flex-row sm:items-center">
          <button
            type="button"
            onClick={handleToggle}
            aria-pressed={enabled}
            className={`flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md px-5 py-3 text-sm font-medium transition-colors ${
              enabled
                ? "border border-accent-300 bg-accent-100 text-accent-800"
                : "bg-primary-500 text-background-50 hover:bg-primary-600"
            }`}
          >
            <span className="flex h-4 w-4 items-center justify-center">
              <i className={enabled ? "ri-notification-3-fill" : "ri-notification-3-line"}></i>
            </span>
            {enabled ? "已开启更新提醒" : "开启更新提醒"}
          </button>
          <span
            className={`text-xs text-foreground-500 transition-opacity ${
              tipVisible ? "opacity-100" : "opacity-0"
            }`}
          >
            {enabled ? "提醒已开启（示例）" : "提醒已关闭（示例）"}
          </span>
        </div>
      </div>
    </section>
  );
}